import { HttpClient } from '@opallabs/api'
import loadWorkflow from '../loadWorkflow'

const deletePhase = ({ workflowId, phaseId, type, identifier }) =>
  HttpClient().delete(
    `/api/v1/${
      type && identifier ? `${type}/${identifier}/` : ''
    }workflow/${workflowId}/phases/${phaseId}`
  )

const destroyPhase =
  ({ type, identifier, workflowId, phaseId }) =>
  (dispatch) =>
    deletePhase({
      identifier,
      type,
      workflowId,
      phaseId,
    })
      .then((response) => dispatch(loadWorkflow(response.data)))
      .catch((err) => {
        console.log(err)
        throw err
      })

export default destroyPhase
